// extracted by mini-css-extract-plugin
export default {"customExpandIcon":"CollapsePanel_customExpandIcon__UQOhI","collapse":"CollapsePanel_collapse__5GN9T","rotate":"CollapsePanel_rotate__2mBtH"};